<template>
  <div>
    <svg id="chart" width="975" height="610"></svg>
  </div>
</template>

<script>
// import * as topojson from "topojson-client";
// import * as d3geo from 'vue-d3-geo';
// const d3 = require('d3');
import { d3map } from "@/lib/d3map";

export default {
  name: "D3map",
  methods: { d3map },
  mounted() {
    // console.log("mounted");

    this.d3map();
  }
};
</script>

<style scoped></style>
